'use client';

import { serializeProductPageToElevarProduct } from '@/lib/utils';
import type { ProductPageProps } from '@veranda/shared/components/pages/product-details/client';
import { ProductViewTracking } from '@veranda/shared/elevar';
import { trackViewedProductKlaviyo } from '@veranda/shared/klaviyo/events';
import { usePathname } from 'next/navigation';

export function ProductViewTrackingWrapper({
  product,
}: { product: ProductPageProps }) {
  const pathname = usePathname();

  const elevarProduct = serializeProductPageToElevarProduct({
    product,
    list: pathname,
  });

  trackViewedProductKlaviyo({
    product,
  });

  return <ProductViewTracking product={elevarProduct} list={pathname} />;
}
